
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {findUsersByEmail, IMayordomoUser} from '@/services/helpdeskUserLookup';

interface ILookupEntry {
  loading: boolean;
  done: boolean;
  users: IMayordomoUser[];
}

@Component({name: 'HelpdeskRelatedEmailsTab'})
export default class HelpdeskRelatedEmailsTab extends Vue {
  @Prop({default: () => []}) emails!: string[];

  emailLookupMap: {[email: string]: ILookupEntry} = {};

  @Watch('emails', {immediate: true})
  onEmailsChanged(val: string[]) {
    (val || []).forEach((email: string) => {
      if (!this.emailLookupMap[email]) {
        this.lookupEmail(email);
      }
    });
  }

  // Resolved via the router so the link works wherever the SPA is hosted (bucket root or /modulo/).
  userHref(userId: number): string {
    return this.$router.resolve({name: 'user', params: {userId: String(userId)}}).href;
  }

  private lookupEmail(email: string) {
    this.$set(this.emailLookupMap, email, {loading: true, done: false, users: []});
    findUsersByEmail(email).then((users) => {
      this.$set(this.emailLookupMap, email, {loading: false, done: true, users});
    });
  }
}
